export default {
  adapters: {
    breadcrumbs: {
      editorial: {
        home: 'Accueil'
      },
      ugr: {
        home: 'Accueil'
      },
      recipes: {
        home: 'Recettes'
      }
    },
    cards: {
      userCollection: {
        // v4 plural
        savedItemDescription_one: 'article',
        savedItemDescription_few: 'articles',
        savedItemDescription_many: 'articles',
        savedItemDescription_other: 'articles',
        // v3 plural
        savedItemDescription: 'article',
        savedItemDescription_plural: 'articles',
        savedItemDescription_0: 'article',
        savedItemDescription_1: 'articles',
        savedItemDescription_2: 'articles'
      },
      userRecipe: {
        statusTextDraft: 'Recette brouillon',
        statusApproved: 'Recette de membre',
        statusPending: 'En attente d\'approbation',
        statusRejected: 'Recette refusée'
      }
    },
    iconAdapter: {
      // v4 plural
      formatTimeHours_one: '{{hours}} h',
      formatTimeHours_few: '{{hours}} h',
      formatTimeHours_many: '{{hours}} h',
      formatTimeHours_other: '{{hours}} h',
      // v3 plural
      formatTimeHours: '{{hours}} h',
      formatTimeHours_plural: '{{hours}} h',
      formatTimeHours_0: '{{hours}} h',
      formatTimeHours_1: '{{hours}} h',
      formatTimeHours_2: '{{hours}} h',
      // v4 plural
      formatTimeMins_one: '{{minutes}} min',
      formatTimeMins_few: '{{minutes}} min',
      formatTimeMins_many: '{{minutes}} min',
      formatTimeMins_other: '{{minutes}} min',
      // v3 plural
      formatTimeMins: '{{minutes}} min',
      formatTimeMins_plural: '{{minutes}} min',
      formatTimeMins_0: '{{minutes}} min',
      formatTimeMins_1: '{{minutes}} min',
      formatTimeMins_2: '{{minutes}} min'
    },
    pageSchema: {
      editorial: {
        recipe: {
          calories: '{{calories}} calories',
          carbContent: '{{carbs}} grammes de glucides',
          fatContent: '{{fat}} grammes de graisses',
          fibreContent: '{{fibre}} grammes de fibres',
          proteinContent: '{{protein}} grammes de protéines',
          satFatContent: '{{saturates}} grammes de graisses saturées',
          sodiumContent: '{{sodium}} milligramme de sodium',
          sugarContent: '{{sugars}} grammes de sucre'
        }
      },
      ugr: {
        servesDefault: 'Sert'
      }
    },
    post: {
      ugr: {
        messageMember: 'Recette de membre',
        messageOther: 'Recette {{status}}',
        statuses: {
          draft: 'brouillon',
          approved: 'approuvé',
          rejected: 'rejeté',
          pending: 'en attente',
          published: 'publié'
        }
      }
    },
    posts: {
      editorial: {
        list: {
          seeMoreText: 'Voir plus'
        },
        liveBlog: {
          // v4 plural
          hour_one: 'il y a une heure',
          hour_few: 'il y a quelques heures',
          hour_many: 'il y a plusieurs heures',
          hour_other: 'il y a quelques heures',
          // v3 plural
          hour: 'il y a une heure',
          hour_plural: 'il y a quelques heures',
          hour_0: 'il y a une heure',
          hour_1: 'il y a quelques heures',
          hour_2: 'il y a quelques heures',
          // v4 plural
          lessThanHour_one: 'il y a une minute',
          lessThanHour_few: 'il y a quelques minutes',
          lessThanHour_many: 'il y a plusieurs minutes',
          lessThanHour_other: 'il y a quelques minutes',
          // v3 plural
          lessThanHour: 'il y a une minute',
          lessThanHour_plural: 'il y a quelques minutes',
          lessThanHour_0: 'il y a une minute',
          lessThanHour_1: 'il y a quelques minutes',
          lessThanHour_2: 'il y a quelques minutes',
          lessThanMinute: 'il y a moins d\'une minute',
          updatedMessageLive: 'Mise à jour EN DIRECT',
          updatedMessageNotLive: 'Mise à jour'
        }
      },
      postAdapter: {
        callout: 'Ceci est un {{entity}} {{status}}',
        previewCallout: 'Aperçu',
        recommendedTitle: 'À lire aussi',
        statuses: {
          draft: 'brouillon',
          approved: 'approuvé',
          rejected: 'rejeté',
          pending: 'en attente',
          preview: 'aperçu',
          published: 'publié'
        },
        entities: {
          glossary: 'glossaire',
          howTo: 'comment faire',
          editorialList: 'liste éditoriale',
          plant: 'plante',
          post: 'post',
          recipe: 'recette',
          review: 'critique',
          'broadcast-show': 'émission de télévision',
          venue: 'lieu',
          page: 'page',
          'user-collection': 'collection d\'utilisateur',
          blog: 'blog'
        }
      },
      recipeAdapter: {
        getPublicationMessage: 'Recette de',
        labels: {
          carbs: 'glucides',
          fat: 'matières grasses',
          fibre: 'fibres',
          protein: 'protéines',
          salt: 'sel',
          saturates: 'dont saturées',
          sugars: 'sucres'
        },
        metricUnits: {
          tbsp: '{{count}} c. à soupe',
          tsp: '{{count}} c. à café'
        },
        nutritionHighInPrefix: 'riche en',
        nutritionLabel: 'Nutrition :',
        nutritionLowInPrefix: 'faible en',
        nutritionLow: '_TODO: low',
        nutritionHigh: '_TODO: high',
        planning: {
          'easily-doubled': 'Facilement doublé',
          'easily-halved': 'Facilement divisé par deux',
          freezable: 'Congelable'
        },
        recommendedAltTitle: 'Notre alternative la plus populaire',
        servingsLabel_one: 'Pour {{count}} personne',
        servingsLabel: 'Pour {{count}} personnes',
        servingsLabel_range: 'Pour {{min}} à {{max}} personnes'
      },
      userRecipeAdapter: {
        categoryDisplay: 'Recettes'
      }
    },
    sponsorTracking: {
      label: 'Coopération publicitaire'
    },
    pageBlocks: {
      riddle: {
        errorMessage: 'There seems to be an issue with the quiz, please try again.'
      }
    }
  },
  controllers: {
    archives: {
      taxonomyDataDisplayLabel: {
        age: 'Age',
        'date-of-birth': 'Date of birth',
        'comes-from': 'Comes from',
        'known-for': 'Known for',
        occupation: 'Occupation',
        'sign-of-the-zodiac': 'Sign of the Zodiac',
        parents: 'Parents',
        spouse: 'Spouse',
        biography: 'Biography'
      }
    },
    search: {
      modifyFilterOptions: {
        transform: {
          time: {
            // v4 plural
            hour_one: '{{hours}} heure',
            hour_few: '{{hours}} heures',
            hour_many: '{{hours}} heures',
            hour_other: '{{hours}} heures',
            // v3 plural
            hour: '{{hours}} heure',
            hour_plural: '{{hours}} heures',
            hour_0: '{{hours}} heure',
            hour_1: '{{hours}} heures',
            hour_2: '{{hours}} heures',
            // v4 plural
            minute_one: '{{minutes}} minute',
            minute_few: '{{minutes}} minutes',
            minute_many: '{{minutes}} minutes',
            minute_other: '{{minutes}} minutes',
            // v3 plural
            minute: '{{minutes}} minute',
            minute_plural: '{{minutes}} minutes',
            minute_0: '{{minutes}} minute',
            minute_1: '{{minutes}} minutes',
            minute_2: '{{minutes}} minutes',
            gte: '{{time}} ou plus',
            gt: 'Plus de {{time}}',
            lte: '{{time}} ou moins',
            lt: 'Moins de {{time}}'
          },
          calories: {
            gteOrGt: 'Plus de {{calories}} kcal',
            lteOrLt: 'Jusqu\'à {{calories}} kcal'
          }
        }
      },
      siteSearchConfig: {
        facet: {
          label: {
            author: 'Auteur',
            calories: 'Calories',
            category: 'Catégories',
            cuisine: 'Cuisine',
            diet: 'Régimes',
            difficulty: 'Difficulté',
            mealType: 'Type de repas',
            occasion: 'Occasion',
            ratings: 'Évaluations',
            servings: 'Portions',
            totalTime: 'Temps total'
          }
        },
        filter: {
          label: {
            articles: 'Actus',
            recipe: 'Recettes',
            video: 'Vidéo',
            guides: 'Guides',
            collection: 'Collections de recettes',
            glossary: 'Glossaire',
            review: 'Critiques'
          }
        },
        sortOptions: {
          label: {
            published: 'Dernier ajouté',
            quickest: 'Le plus rapide',
            rating: 'Le plus populaire',
            relevant: 'Le plus pertinent'
          }
        }
      }
    }
  }
};